"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebrtcConnectorRpcLocal = void 0;
const utils_1 = require("@streamr/utils");
const AddressTools_1 = require("../../helpers/AddressTools");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class WebrtcConnectorRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async requestConnection(context) {
        const targetPeerDescriptor = context.incomingSourceDescriptor;
        if (this.options.ongoingConnectAttempts.has((0, identifiers_1.toNodeId)(targetPeerDescriptor))) {
            return {};
        }
        const pendingConnection = this.options.connect(targetPeerDescriptor, false);
        this.options.onNewConnection(pendingConnection);
        return {};
    }
    async rtcOffer(request, context) {
        const remotePeerDescriptor = context.incomingSourceDescriptor;
        const nodeId = (0, identifiers_1.toNodeId)(remotePeerDescriptor);
        let connection;
        let pendingConnection;
        if (!this.options.ongoingConnectAttempts.has(nodeId)) {
            pendingConnection = this.options.connect(remotePeerDescriptor, true);
            connection = this.options.ongoingConnectAttempts.get(nodeId).connection;
            this.options.onNewConnection(pendingConnection);
        }
        else {
            pendingConnection = this.options.ongoingConnectAttempts.get(nodeId).managedConnection;
            connection = this.options.ongoingConnectAttempts.get(nodeId).connection;
        }
        // Always use offerers connectionId
        connection.setConnectionId(request.connectionId);
        connection.setRemoteDescription(request.description, 'offer');
        return {};
    }
    async rtcAnswer(request, context) {
        const remotePeerDescriptor = context.incomingSourceDescriptor;
        const nodeId = (0, identifiers_1.toNodeId)(remotePeerDescriptor);
        const connection = this.options.ongoingConnectAttempts.get(nodeId)?.connection;
        if (!connection) {
            return {};
        }
        else if (connection.connectionId !== request.connectionId) {
            logger.trace(`Ignoring RTC answer due to connectionId mismatch`);
            return {};
        }
        connection.setRemoteDescription(request.description, 'answer');
        return {};
    }
    async iceCandidate(request, context) {
        const remotePeerDescriptor = context.incomingSourceDescriptor;
        const nodeId = (0, identifiers_1.toNodeId)(remotePeerDescriptor);
        const connection = this.options.ongoingConnectAttempts.get(nodeId)?.connection;
        if (!connection) {
            return {};
        }
        else if (connection.connectionId !== request.connectionId) {
            logger.trace(`Ignoring remote candidate due to connectionId mismatch`);
            return {};
        }
        else if (this.isIceCandidateAllowed(request.candidate)) {
            connection.addRemoteCandidate(request.candidate, request.mid);
        }
        return {};
    }
    isIceCandidateAllowed(candidate) {
        if (!this.options.allowPrivateAddresses) {
            const address = (0, AddressTools_1.getAddressFromIceCandidate)(candidate);
            if ((address !== undefined) && (0, AddressTools_1.isPrivateIPv4)(address)) {
                return false;
            }
        }
        return true;
    }
}
exports.WebrtcConnectorRpcLocal = WebrtcConnectorRpcLocal;
//# sourceMappingURL=WebrtcConnectorRpcLocal.js.map